import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Al cambiar de ruta, hace scroll automático al top de la página.
 *
 * Soluciona el bug donde al abrir páginas largas (Cliente 360, KPIs, etc.)
 * desde links que cambian de ruta, react-router no resetea el scroll y la
 * página aparece en una posición intermedia o en el footer.
 *
 * Se monta una sola vez en App.tsx; no renderiza nada.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Usamos "auto" en lugar de "smooth" para que sea instantáneo al navegar.
    // El smooth lo dejamos para el botón "ir al top" del FAB.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
